import React, { useState } from 'react';

function Group({ label, rows, selectedId, onSelect, shared }) {
  if (!rows.length) return null;
  return (
    <div className="ls-group">
      <div className="ls-group__label">{label}</div>
      {rows.map((r) => (
        <button key={r.id} type="button" onClick={() => onSelect(r.id)}
          className={`ls-irow ${selectedId === r.id ? 'ls-irow--active' : ''}`}
          aria-current={selectedId === r.id ? 'true' : undefined}
          data-testid={`lists_row_${r.id}`}>
          <span className="ls-irow__text">
            <span className="ls-irow__title">{r.title}</span>
            <span className="ls-irow__sub">{shared && r.owner_name ? `From ${r.owner_name}${r.via === 'code' ? ' · opened by code' : ''}` : (r.sport || '')}</span>
          </span>
          <span className="ls-irow__count">{r.athlete_count}</span>
        </button>
      ))}
    </div>
  );
}

function OpenByCode({ onOpen }) {
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const submit = async (e) => {
    e.preventDefault();
    if (!code.trim() || busy) return;
    setBusy(true); setError('');
    const problem = await onOpen(code.trim());
    setBusy(false);
    if (problem) setError(problem); else setCode('');
  };
  return (
    <form className="ls-code" onSubmit={submit}>
      <input className="ls-code__input" value={code} onChange={(e) => setCode(e.target.value)} placeholder="Open by code…"
        aria-label="Open a list by code" data-testid="lists_code" autoComplete="off" />
      <button type="submit" className="ls-btn ls-btn--dark ls-btn--tiny" disabled={busy || !code.trim()} data-testid="lists_code_go">Open</button>
      {error && <p className="ls-code__error" role="alert">{error}</p>}
    </form>
  );
}

export default function ListIndex({ mine, shared, team = [], selectedId, onSelect, onNew, filter, onFilter, onOpenCode }) {
  const q = filter.trim().toLowerCase();
  const keep = (r) => !q || (r.title || '').toLowerCase().includes(q);
  const m = mine.filter(keep);
  const s = shared.filter(keep);
  const t = team.filter(keep);
  return (
    <aside className="adm__card ls-index" data-testid="lists_index" aria-label="Lists">
      <div className="ls-index__head">
        <h1 className="ls-index__title">Lists</h1>
        <button type="button" className="ls-btn ls-btn--primary" onClick={onNew} data-testid="lists_new">+ New list</button>
      </div>
      <input type="search" className="ls-find" placeholder="Find a list…" value={filter}
        onChange={(e) => onFilter(e.target.value)} aria-label="Find a list" data-testid="lists_find" />
      {onOpenCode && <OpenByCode onOpen={onOpenCode} />}
      <Group label="MY LISTS" rows={m} selectedId={selectedId} onSelect={onSelect} />
      <Group label="SHARED WITH ME" rows={s} selectedId={selectedId} onSelect={onSelect} shared />
      <Group label="ALL LISTS" rows={t} selectedId={selectedId} onSelect={onSelect} shared />
      {!mine.length && !shared.length && !team.length && <p className="ls-empty">No lists yet. Create one to start collecting athletes.</p>}
      {(mine.length > 0 || shared.length > 0 || team.length > 0) && !m.length && !s.length && !t.length && <p className="ls-empty">No lists match.</p>}
    </aside>
  );
}
